import {
  Div,
  H5,
  Icon,
  Img,
  Modal,
  P,
  PlusIcon,
  PropsModal,
  moneyAndCoins,
} from '@vgrubs/components';
import { AgentEarningLevel } from '../../UsersAndAccess/UserDetails/UserDetailsAgent';
import { AgentAvatars } from './AgentAvatars';
import {
  EarningPlan,
  EarningPlanVOrdersVDrive,
  ServiceAgents,
} from './EarningPlanComponents';
import { SetStateAction } from 'react';
import { Dispatch } from 'react';
import {
  AgentDetails,
  EarningPlanEntity,
} from 'components/src/types/location.types';
import {
  LocationAgent,
  LocationAgentServiceKey,
  LocationAgentsEarningPlans,
} from 'components/src/types/api/location.types';

export const EarningPlans = ({
  earningPlans,
  closeModal,
  modalIsOpen,
  earning,
  setAddEarningPlansModal,
  onEditPlan,
  setEditVOrderPlans,
  setEditVDrivePlans,
  agents,
  agentsData,
  onAddAgentToService,
  onDeleteAgentFromService,
  onViewAgents,
  onSaveShares,
}: PropsModal & {
  earningPlans: Partial<EarningPlanEntity>[];
  modalIsOpen: boolean;
  earning: AgentDetails | null;
  setAddEarningPlansModal: Dispatch<SetStateAction<boolean>>;
  onEditPlan: (
    plan: Partial<EarningPlanEntity>,
    index: number,
    label: string
  ) => void;
  setEditVOrderPlans: Dispatch<SetStateAction<boolean>>;
  setEditVDrivePlans: Dispatch<SetStateAction<boolean>>;
  agents: LocationAgent[];
  agentsData: LocationAgentsEarningPlans | null;
  onAddAgentToService: (service: {
    key: LocationAgentServiceKey;
    label: string;
  }) => void;
  onDeleteAgentFromService: (
    agentId: number,
    service: LocationAgentServiceKey
  ) => void;
  onViewAgents: () => void;
  onSaveShares: (
    service: LocationAgentServiceKey,
    amounts: { agentId: number; amount: number }[]
  ) => Promise<boolean> | void;
}) => {
  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Earning Plans"
      textAlign={'left'}
    >
      <div>
        <Div $flex $between $alignCenter $gap="16px">
          <AgentEarningLevel level={earning?.agentLevel} />
          <AgentAvatars agents={agents} onShowAll={onViewAgents} />
        </Div>

        <Div $flex $between $alignCenter $m="24px 0 16px 0">
          <H5 $m="0">vGrubs Earning Plans</H5>
          {earning?.vGrubsService && (
            <Icon $pointer onClick={() => setAddEarningPlansModal(true)}>
              <PlusIcon />
            </Icon>
          )}
        </Div>
        {earning?.vGrubsService &&
          earningPlans.length > 0 &&
          earningPlans
            .sort((a, b) => {
              if (a.year === null) {
                return 1; // Put null year at the end
              }
              if (b.year === null) {
                return -1; // Put null year at the end
              }
              return (a.year || 0) - (b.year || 0);
            })
            .map((plan, i) => (
              <EarningPlan
                key={i}
                plan={plan}
                onEditPlan={onEditPlan}
                index={i}
                agentsContent={
                  plan.active ? (
                    <ServiceAgents
                      service="vGrubs"
                      label="vGrubs"
                      enabled={!!agentsData?.vGrubs.enabled}
                      total={agentsData?.vGrubs.total || 0}
                      agents={agentsData?.vGrubs.agents || []}
                      onAdd={() =>
                        onAddAgentToService({ key: 'vGrubs', label: 'vGrubs' })
                      }
                      onDelete={(agentId) =>
                        onDeleteAgentFromService(agentId, 'vGrubs')
                      }
                      onSaveShares={onSaveShares}
                    />
                  ) : undefined
                }
              />
            ))}

        {!earning?.vGrubsService && (
          <EarningPlanVOrdersVDrive
            planName={'Earning Plan'}
            amount={0}
            isEnabled={false}
          />
        )}

        {earning?.vGrubsService && earningPlans.length === 0 && (
          <Div $flex $column $alignCenter>
            <Img src={moneyAndCoins} alt="no earning plans" $width="150px" />
            <P $mb="16">No vGrubs Earning Plans</P>
          </Div>
        )}

        <H5 $m="24px 0 16px 0">vTablet Earning Plans</H5>

        <EarningPlanVOrdersVDrive
          planName={'SaaS Plan'}
          amount={earning?.vOrdersCommision || 0}
          isEnabled={earning?.vOrdersService || false}
          setModalIsOpen={setEditVOrderPlans}
          agentsContent={
            agentsData?.vOrders.enabled ? (
              <ServiceAgents
                service="vOrders"
                label="vTablet"
                enabled={!!agentsData?.vOrders.enabled}
                total={agentsData?.vOrders.total || 0}
                agents={agentsData?.vOrders.agents || []}
                onAdd={() =>
                  onAddAgentToService({ key: 'vOrders', label: 'vTablet' })
                }
                onDelete={(agentId) =>
                  onDeleteAgentFromService(agentId, 'vOrders')
                }
                onSaveShares={onSaveShares}
              />
            ) : undefined
          }
        />

        <H5 $m="24px 0 16px 0">vDrive Earning Plans</H5>

        <EarningPlanVOrdersVDrive
          planName={'vDrive Sales Fee'}
          amount={earning?.vDriveCommission || 0}
          isEnabled={earning?.vDriveService || false}
          setModalIsOpen={setEditVDrivePlans}
          agentsContent={
            agentsData?.vDrive.enabled ? (
              <ServiceAgents
                service="vDrive"
                label="vDrive"
                enabled={!!agentsData?.vDrive.enabled}
                total={agentsData?.vDrive.total || 0}
                agents={agentsData?.vDrive.agents || []}
                onAdd={() =>
                  onAddAgentToService({ key: 'vDrive', label: 'vDrive' })
                }
                onDelete={(agentId) =>
                  onDeleteAgentFromService(agentId, 'vDrive')
                }
                onSaveShares={onSaveShares}
              />
            ) : undefined
          }
        />
      </div>
    </Modal>
  );
};
